import Home, { Props } from "./Home";

export default Home;
export type { Props };
